module.exports = __webpack_public_path__ + "img/trip-fuel-idle.deca4196.svg";